<template>
  <form>
    <div class="row">
      <div class="col-sm-12 row">
        <div class="card-body">
          <div class="row">
            <div class="col-4">
              <TextField 
                :placeholder="$t('user.form.first_name.placeholder')"
                :label="$t('user.form.first_name.label')"
                v-model="model.first_name"
              />
            </div>

            <div class="col-4">
              <TextField 
                :placeholder="$t('user.form.middle_name.placeholder')"
                :label="$t('user.form.middle_name.label')"
                v-model="model.middle_name"
              />
            </div>

            <div class="col-4">
              <TextField 
                :placeholder="$t('user.form.last_name.placeholder')"
                :label="$t('user.form.last_name.label')"
                v-model="model.last_name"
              />
            </div>
            <div class="col-4">
              <TextField 
                :placeholder="$t('candidate.form.jp_first_name.placeholder')"
                :label="$t('candidate.form.jp_first_name.label')"
                v-model="model.first_name_kana"
              />
            </div>

            <div class="col-4">
              <TextField 
                :placeholder="$t('candidate.form.jp_middle_name.placeholder')"
                :label="$t('candidate.form.jp_middle_name..label')"
                v-model="model.middle_name_kana"
              />
            </div>

            <div class="col-4">
              <TextField 
                :placeholder="$t('candidate.form.jp_last_name.placeholder')"
                :label="$t('candidate.form.jp_last_name.label')"
                v-model="model.last_name_kana"
              />
            </div>
            
            <div class="col-4">
              <TextField 
                placeholder="hello@hrtech.com"
                :label="$t('user.form.email.label')"
                type="email"
                autocomplete="off"
                v-model="model.email"
              />
            </div>
            <div class="col-4">
              <DropDown 
                :placeholder="$t('candidate.form.gender.placeholder')"
                :label="$t('candidate.form.gender.label')"
                :name.sync="model.gender"
                v-model="model.gender"
                :options="genderOption"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import  FormMixin from '@mixins/form'

export default {
  components: {
    TextField: () => import('@components/form/textfield.vue'),
    DropDown: () => import('@components/form/dropdown.vue'),
  },
  mixins: [ FormMixin ],
  data () {
    return {
      model: {},
      genderOption: [
        {value: 'MALE', text: 'MALE'},
        {value: 'FEMALE', text: 'FEMALE'},
        {value: 'OTHER', text: 'OTHER'}
      ],
    }
  },
  props: {
    parameters: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    rowId() {
      let parameters = this.parameters || {}
      return parameters.rowId
    },
    submitted() {
      let parameters = this.parameters || {}
      return parameters.submitted
    }
  },
  methods: {
    findContact() {
      return this.$store.dispatch('company/findContactPerson', { id: this.rowId })
      .then(result => {
        if (result && result.data) {
          this.model = result.data
        }
      })
      .catch(err => console.log(err))
    }
  },
  watch: {
    rowId: function () {
      this.findContact()
    },
    submitted: function () {
      this.findContact()
    }
  },
  mounted() {
    if (this.rowId) {
      this.findContact()
    }
  }
}
</script>